import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as func from "../../common/athleteCommon/FunctionCalls";

interface Props {
    formData: any;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const MedicalProfile: React.FC<Props> = ({ formData, onChange }) => {

    // const ctgryLst = [{ ctgryId: 1, ctgryName: "Cardiovascular" }, { ctgryId: 2, ctgryName: "Respiratory" }, { ctgryId: 3, ctgryName: "Anti-inflamatory" }, { ctgryId: 4, ctgryName: "Pain Management" }, { ctgryId: 5, ctgryName: "Mental Health" }, { ctgryId: 6, ctgryName: "Harmonal" }, { ctgryId: 7, ctgryName: "Other" }]

    const [ctgryLst, setCtgryLst] = useState<any[]>([]);
    const [alrgyTypList, setAlrgyTypList] = useState<any[]>([]);

    useEffect(() => {
        async function getMedProfile() {
            const medResponse = await func.medicationCategory(null);
            setCtgryLst(Array.isArray(medResponse) ? medResponse : []);
            const alrgyResponse = await func.allergyType(null);
            setAlrgyTypList(Array.isArray(alrgyResponse) ? alrgyResponse : []);
        }
        getMedProfile();
    }, [])

    const handleSelectChange = (name: string) =>
        (option: any) => {
            const value = Array.isArray(option)
                ? option.map(o => o.value)
                : option?.value ?? "";

            onChange({
                target: { name, value }
            } as React.ChangeEvent<HTMLInputElement>);
        };

    return (
        <>
            <div className="card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-4">
                            <h4>Is there no medical history?</h4>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-check form-switch d-flex align-items-center justify-content-start">
                                <input
                                    className="form-check-input text-end"
                                    type="checkbox"
                                    checked={formData.noHistory === '1'}
                                    name="noHistory"
                                    // onChange={onChange}
                                    onChange={(e) =>
                                        onChange({
                                            target: {
                                                name: "noHistory",
                                                value: e.target.checked ? "1" : "0"
                                            }
                                        } as React.ChangeEvent<HTMLInputElement>)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    {(formData.noHistory != "1") ?
                        <>
                            <div className="row">
                                <div className="col-lg-6">
                                    <label className="form-label">Allergy Type</label>
                                    <Select
                                        value={alrgyTypList.find(alrgy => alrgy.allergyId === formData.allergies) ? {
                                            value: formData.allergies,
                                            label: alrgyTypList.find(alrgy => alrgy.allergyId === formData.allergies)?.allergyName
                                        } : null}
                                        onChange={handleSelectChange("allergies")}
                                        placeholder="Select Allergy Type"
                                        options={alrgyTypList.map(alrgy => ({
                                            value: alrgy.allergyId,
                                            label: alrgy.allergyName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">Allergy Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="allergiesDescription"
                                        value={formData.allergiesDescription}
                                        onChange={onChange}
                                        placeholder="Enter Allergy Name" />
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">Known Medical Conditions</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="medicalCondition"
                                        value={formData.medicalCondition}
                                        onChange={onChange}
                                        placeholder="Enter Medical Condition" />
                                </div>
                                <h5 className="text-uppercase mt-2">Medication</h5>
                                <div className="col-lg-6">
                                    <label className="form-label">Category</label>
                                    <Select
                                        value={ctgryLst.find(ctgry => ctgry.medicationCategoryId === formData.category) ? {
                                            value: formData.category,
                                            label: ctgryLst.find(ctgry => ctgry.medicationCategoryId === formData.category)?.name
                                        } : null}
                                        name="category"
                                        onChange={handleSelectChange("category")}
                                        placeholder="Select Category"
                                        options={ctgryLst.map(ctgry => ({
                                            value: ctgry.medicationCategoryId,
                                            label: ctgry.name
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">Current Medications</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="currentMedication"
                                        value={formData.currentMedication}
                                        onChange={onChange}
                                        placeholder="Enter Current Medication" />
                                </div>
                            </div>
                        </> : null}
                </div>
            </div>
            {/* </div > */}
        </>
    );
};

export default MedicalProfile;